// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

export const CLOSE_CASE = "mondoo.policy.ExtendedHub.CloseCase";
